import { Option } from 'components';

export const mqList: Option[] = [
    { value: '', label: 'Empty' },
    { value: 'certification-practice-center.fifo', label: 'Kaspersky Global' },
];
